import { z } from "zod"

/** Validated `/settings/clients` search params. */
export const clientsSettingsSearchSchema = z.object({
  q: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.string().min(1).max(200).optional(),
  ),
  limit: z.coerce.number().int().min(1).max(200).default(25),
  offset: z.coerce.number().int().min(0).default(0),
  sort: z.string().default("name.asc"),
})

export type ClientsSettingsSearch = z.infer<typeof clientsSettingsSearchSchema>

export const defaultClientsSettingsSearch: ClientsSettingsSearch = clientsSettingsSearchSchema.parse({})
